import request from './request';
/**
 * 新增广告
 */
export function addAd(params) {
    return request('/ad', {
        method: 'POST',
        params,
    });
}
/**
 * 详情
 */
export function getDetail(params) {
    return request(`/ad/${params}`, {
        method: 'GET',
        params,
    });
}
/**
 * 编辑广告
 */
export function editAd(params) {
    return request('/ad', {
        method: 'PUT',
        params,
    });
}
/**
 * 列表
 */
export function getList(params) {
    return request('/ad/list', {
        method: 'POST',
        params,
    });
}
/**
 * 预览
 */
export function previewAd(params) {
    return request('/ad/content', {
        method: 'POST',
        params,
    });
}
/**
 * 排序和上下线
 */
export function status(params) {
    return request('/ad/status', {
        method: 'PATCH',
        params,
    });
}
/**
 * 首页轮播图专用
 */
export function getBannerList(params) {
    return request('/ad/home-list', {
        method: 'GET',
        params,
    });
}
/**
 * 获取广告发布人
 */
export function getOrgAlias(params) {
    return request('/ad/org-alias', {
        method: 'GET',
        params,
    });
}
/**
 * 广告APPpush次数统计
 */
export function getAppPushCount(params) {
    return request(`/ad/app-push-count/${params.id}/${params.category}`, {
        method: 'GET',
    });
}
/**
 * 集团版投放门店详情
 */
export function getIssuedShop(advertId) {
    return request(`/ad/issued-shop/${advertId}`, {
        method: 'GET',
    });
}
/**
 * 集团版投放门店详情
 */
export function editIssuedRange(params) {
    return request('/ad/issued-range', {
        method: 'PUT',
        params,
    });
}
/**
 * 集团版投放门店详情
 */
export function checkOnlineCountLimit(params) {
    return request('ad/checkOnlineCountLimit', {
        method: 'GET',
        params,
    });
}
